module.exports = __webpack_public_path__ + "static/media/Icon2.751004d0.png";